import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import Select from "react-select";

const PmFgMappingMaster = () => {
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [pmSkuOptions, setPmSkuOptions] = useState([]);
  const [fgSkuOptions, setFgSkuOptions] = useState([]);
  
  const [selectedPmSku, setSelectedPmSku] = useState(null);
  const [selectedFgSku, setSelectedFgSku] = useState(null);
  
  const [editFormData, setEditFormData] = useState({
    pm_sku_code: "",
    pm_type: "",
    pm_category: "",
    pm_sku_name: "",
    fg_sku_code: "",
    fg_category: ""
  });

  // Select Styles
  const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '1px',
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
      minHeight: '38px'
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 'normal',
      color: '#333',
      fontSize: "12px"
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      fontWeight: state.isSelected ? 'normal' : 'normal',
    })
  };

  const columnWithDefs = [
    {
      headerName: "",
      field: "actions",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell", 
      cellRendererFramework: (params) => (
        <div style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}>
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params.data)}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    {
      headerName: "PM SKU Code",
      field: "pm_sku_code",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "PM Type",
      field: "pm_type",
      sortable: true,
      resizable: true,
      width: 120,
    },
    {
      headerName: "PM Category",
      field: "pm_category",
      sortable: true,
      resizable: true,
      width: 180,
    },
    {
      headerName: "PM SKU Name",
      field: "pm_sku_name",
      sortable: true,
      resizable: true,
      width: 300,
    },
    {
      headerName: "FG SKU Code",
      field: "fg_sku_code",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "FG Category",
      field: "fg_category",
      sortable: true,
      resizable: true,
      width: 180,
    },
    {
      headerName: "Inserted Date",
      field: "inserted_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    },
    {
      headerName: "Updated Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    }
  ];

  const getPmSkuOptions = async () => {
    try {
      const response = await redirectURL.post("masters/getPmSkuMasterData", {});
      if (response.status === 200 && response.data.data) {
        const options = response.data.data.map(item => ({
          value: item.pm_sku_code,
          label: item.pm_sku_code, // Only show PM SKU Code
          data: item // Store full data for auto-fill
        }));
        setPmSkuOptions(options);
      }
    } catch (error) {
      console.error("Error fetching PM SKU options:", error);
    }
  };

  const getFgSkuOptions = async () => {
    try {
      const response = await redirectURL.post("masters/getSkuMasterData", {});
      if (response.status === 200 && response.data.data) {
        const options = response.data.data.map(item => ({
          value: item.sku_code,
          label: item.sku_code, // Only show FG SKU Code
          data: item // Store full data for auto-fill
        }));
        setFgSkuOptions(options);
      }
    } catch (error) {
      console.error("Error fetching FG SKU options:", error);
    }
  };

  const handlePmSkuChange = (selectedOption) => {
    setSelectedPmSku(selectedOption);
    if (selectedOption) {
      const pmData = selectedOption.data;
      setEditFormData(prev => ({
        ...prev,
        pm_sku_code: pmData.pm_sku_code,
        pm_type: pmData.pm_type || "",
        pm_category: pmData.pm_category || "",
        pm_sku_name: pmData.pm_sku_name || ""
      }));
    } else {
      setEditFormData(prev => ({
        ...prev,
        pm_sku_code: "",
        pm_type: "",
        pm_category: "",
        pm_sku_name: ""
      }));
    }
  };

  const handleFgSkuChange = (selectedOption) => {
    setSelectedFgSku(selectedOption);
    if (selectedOption) {
      const fgData = selectedOption.data;
      setEditFormData(prev => ({
        ...prev,
        fg_sku_code: fgData.sku_code,
        fg_category: fgData.sku_category || ""
      }));
    } else {
      setEditFormData(prev => ({
        ...prev,
        fg_sku_code: "",
        fg_category: ""
      }));
    }
  };

  // Reset Form Data
  const resetFormData = () => {
    setEditFormData({ 
      pm_sku_code: "",
      pm_type: "",
      pm_category: "",
      pm_sku_name: "",
      fg_sku_code: "",
      fg_category: ""
    });
    setSelectedPmSku(null);
    setSelectedFgSku(null);
  };

  // Hide Overlay and Slider
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const onClickAddNewPmFgMapping = async () => {
    await getPmSkuOptions();
    await getFgSkuOptions();
    
    resetFormData();
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Add New PM FG Mapping");
    setOverlyBlock("show-m");
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 100,
  };

  const getPmFgMappingData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      
      const response = await redirectURL.post("masters/getPmFgMappingData", {});
      
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setTimeout(() => autoSizeAllColumns(), 100);
        } else {
          setBasicTitle("No PM FG Mapping data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching PM FG Mapping data:", error);
      setBasicTitle("Failed to fetch PM FG Mapping data");
      setBasicType("error");
      setShow(true);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setSliderOpen(false);
    resetFormData();
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const handleAddPmFgMapping = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    const params = {
      pm_sku_code: editFormData.pm_sku_code,
      pm_type: editFormData.pm_type,
      pm_category: editFormData.pm_category,
      pm_sku_name: editFormData.pm_sku_name,
      fg_sku_code: editFormData.fg_sku_code,
      fg_category: editFormData.fg_category
    };

    const requiredFields = ['pm_sku_code', 'pm_type', 'pm_category', 'pm_sku_name', 'fg_sku_code', 'fg_category'];
    const validationErrors = requiredFields.filter(
      (key) => !params[key] || params[key].toString().trim() === ""
    );

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post("masters/addPmFgMapping", params);
      
      if (response.status === 200 && response.data.status === "success") {
        await getPmFgMappingData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("PM FG Mapping Added Successfully");
        setSliderOpen(false);
        setOverlyBlock("show-n");
        
        // RESET FORM DATA AFTER SUCCESSFUL ADD
        resetFormData();
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New PM FG Mapping Added",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message || "Failed to add PM FG Mapping");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New PM FG Mapping Added",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      const message = error.response?.data?.message || "An error occurred";
      setShow(true);
      setBasicType("info");
      setBasicTitle(message);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      
      // User Action Triggering
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "New PM FG Mapping Added",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    try {
      const response = await redirectURL.post("masters/deletePmFgMapping", {
        id: selectedRow._id
      });
      
      if (response.data.status === "success") {
        await getPmFgMappingData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("PM FG Mapping Deleted Successfully");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "PM FG Mapping Deleted",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete PM FG Mapping");
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "PM FG Mapping Deleted",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete PM FG Mapping");
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "PM FG Mapping Deleted",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  };

  useEffect(() => {
    getPmFgMappingData();
  }, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>
              PM FG Mapping Master
            </h1>
          </div>
          
          <div className="col-sm-12 mb-4 d-flex justify-content-end">
            <button 
              onClick={onClickAddNewPmFgMapping}
              style={{
                ...addButtonStyle,
                backgroundColor: "#93385D",
                color: "#fff",
                border: "2px solid #93385D",
              }}
            >
              <IoMdAdd style={{ color: "#fff", fontSize: "18px" }} />
              {" Add New"}
            </button>
          </div>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{ suppressHorizontalScroll: false }}
                onGridReady={onGridReady}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Add */}
      <div className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`} style={{ width: "25%" }}>
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p className="m-0p" style={{ cursor: "pointer" }} onClick={onClickingSliderCloseIcon}>
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {/* Add Form */}
        {sliderType === 1 && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "100%", 
            overflow: "hidden" 
          }}>
            <form style={{ 
              flexGrow: 1, 
              overflowY: "auto", 
              padding: "20px",
              height: "100%"
            }}>
              <div style={{ paddingBottom: "20px" }}>
                {/* PM SKU Code Dropdown */}
                <div className="form-group">
                  <label htmlFor="pm_sku_code" style={labelStyle}>
                    PM SKU Code <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    id="pm_sku_code"
                    options={pmSkuOptions}
                    value={selectedPmSku}
                    onChange={handlePmSkuChange}
                    placeholder="Select PM SKU Code"
                    styles={selectStyles}
                    isClearable
                    isSearchable
                    required
                  />
                </div>

                {/* PM Type (Auto-filled) */}
                <div className="form-group">
                  <label htmlFor="pm_type" style={labelStyle}>
                    PM Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pm_type"
                    value={editFormData.pm_type}
                    placeholder="Auto-filled from PM SKU selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                {/* PM Category (Auto-filled) */}
                <div className="form-group">
                  <label htmlFor="pm_category" style={labelStyle}>
                    PM Category <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pm_category"
                    value={editFormData.pm_category}
                    placeholder="Auto-filled from PM SKU selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="pm_sku_name" style={labelStyle}>
                    PM SKU Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pm_sku_name"
                    value={editFormData.pm_sku_name}
                    placeholder="Auto-filled from PM SKU selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                {/* FG SKU Code Dropdown */}
                <div className="form-group">
                  <label htmlFor="fg_sku_code" style={labelStyle}>
                    FG SKU Code <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    id="fg_sku_code"
                    options={fgSkuOptions}
                    value={selectedFgSku}
                    onChange={handleFgSkuChange}
                    placeholder="Select FG SKU Code"
                    styles={selectStyles}
                    isClearable
                    isSearchable
                    required
                  />
                </div>

                {/* FG Category (Auto-filled) */}
                <div className="form-group">
                  <label htmlFor="fg_category" style={labelStyle}>
                    FG Category <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="fg_category"
                    value={editFormData.fg_category}
                    placeholder="Auto-filled from FG SKU selection"
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f9f9f9",
                      cursor: "not-allowed",
                      color: "#666"
                    }}
                    disabled
                    required
                  />
                </div>

                {/* Submit Button */}
                <div style={submitButtonContainerStyle}>
                  <button
                    type="button"
                    onClick={handleAddPmFgMapping}
                    style={submitButtonStyle}
                  >
                    ADD
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>

      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={deletePopupStyle}
        >
          <div className="inventory-delete-popup">
            <p style={deletePopupTextStyle}>
              {`Are you sure you want to delete mapping for ${selectedRow ? selectedRow.pm_sku_code : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button className="btn btn-danger" onClick={onClickingPopupDeleteBtn}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={onClickDeletePopupCancelBtn}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "8px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "5px"
};

const labelStyle = {
  fontSize: "0.9rem",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "8px",
  display: "block"
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "0.9rem",
  marginBottom: "15px"
};

const submitButtonContainerStyle = {
  textAlign: "right",
  marginTop: "20px",
  paddingTop: "15px",
  borderTop: "1px solid #eee"
};

const submitButtonStyle = {
  backgroundColor: "#93385D",
  color: "#fff",
  padding: "10px 30px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold"
};

const deletePopupStyle = {
  position: "fixed",
  top: "40%",
  left: "40%",
  zIndex: "1003",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
};

const deletePopupTextStyle = {
  color: "grey",
  fontSize: "16px",
  textAlign: "center",
  fontWeight: "bold",
  marginBottom: "20px",
};

export default PmFgMappingMaster;